class QuotationsService {
  constructor ($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.$httpParamSerializerJQLike= $httpParamSerializerJQLike;
  }

  getQuotationsHead(userDocument) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.PAYMENT_ADVANCED.QUOTATIONS_HEAD +
        (userDocument ? '?valor=' + userDocument : ''),
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  getQuotationsDetail(documentNumber) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'GET',
        url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.PAYMENT_ADVANCED.QUOTATIONS_DETAIL +
        (documentNumber ? '?valor=' + documentNumber : ''),
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  userUpdate(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + '/' + this.ngAuthSettings.config.paths.userUpdate,
        data: this.$httpParamSerializerJQLike(data),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
}

QuotationsService.$inject = ['$q','$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

export default QuotationsService;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/payments-advances/quotations/quotations.service.js
 **/